import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { LiksIconButton } from '../../../components/liks/LiksIconButton/LiksIconButton';
import type { DocumentSortField } from '../../../types/knowledge';

type KnowledgeDocumentsSortableHeaderProps = {
  label: string;
  column: DocumentSortField;
  activeColumn: DocumentSortField;
  direction: 'ASC' | 'DESC' | null;
  className?: string;
  translate: (key: string, params?: Record<string, string>) => string;
  onSortToggle: (column: DocumentSortField) => void;
};

export function KnowledgeDocumentsSortableHeader({
  label,
  column,
  activeColumn,
  direction,
  className,
  translate,
  onSortToggle,
}: KnowledgeDocumentsSortableHeaderProps) {
  const isActive = activeColumn === column;
  const sortDirection = isActive ? direction : null;
  const SortIcon =
    sortDirection === 'ASC'
      ? ArrowUp
      : sortDirection === 'DESC'
        ? ArrowDown
        : ArrowUpDown;
  const sortStateLabel =
    sortDirection === 'ASC'
      ? translate('knowledge.table.sortAscending')
      : sortDirection === 'DESC'
        ? translate('knowledge.table.sortDescending')
        : translate('knowledge.table.sortUnsorted');

  return (
    <th scope="col" className={className}>
      <div className="knowledge-database__table-header">
        <span>{label}</span>
        <LiksIconButton
          type="button"
          className={[
            'knowledge-database__sort-button',
            isActive &&
              sortDirection &&
              `knowledge-database__sort-button--${sortDirection.toLowerCase()}`,
          ]
            .filter(Boolean)
            .join(' ')}
          aria-label={translate('knowledge.table.sortColumn', {
            column: label,
            state: sortStateLabel,
          })}
          onClick={() => onSortToggle(column)}
        >
          <SortIcon aria-hidden />
        </LiksIconButton>
      </div>
    </th>
  );
}
